<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1>Add new</h1>
      </v-col>
      <v-col cols="12" md="6">
        <v-file-input v-model="newItem.link " label="Photo"></v-file-input>
      </v-col>
      <v-col cols="12" md="6">
        <v-select
          v-model="newItem.level"
          :items="titles"
          item-text="name"
          item-value="id"
          label="Sponsor Level"
        ></v-select>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="newItem.name"
          label="Name"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-btn :loading="loading" color="white" elevation="1" @click="create">Add</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="d-flex" cols="12">
        <v-select
          v-model="id"
          :items="sponsors"
          item-text="name"
          item-value="id"
          dense
          label="Sponsor to edit"
          filled
          v-on:change="updateItem"
        ></v-select>
      </v-col>
    </v-row>
    <v-row v-if="id">
      <v-col cols="12" md="6">
        <v-img class="image" contain :src="item.link"></v-img>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field v-model="item.name" label="Name"></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-file-input v-model="newFile" label="New photo" ></v-file-input>
      </v-col>
      <v-col cols="12" md="7">
        <v-select
          v-model="item.level"
          :items="titles"
          item-text="name"
          item-value="id"
          label="Sponsor Level"
        ></v-select>
      </v-col>
      <v-col cols="6">
        <v-btn :loading="loading" color="white" elevation="1" @click="update">Update</v-btn>
      </v-col>
      <v-col cols="6">
        <v-btn :loading="loading" color="red" elevation="1" @click="delet">Delete</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { uploadPhoto } from "@/helpers/storage.js";

export default {
  name: "EditSponsors",
  data() {
    return {
      id: null,
      item: {},
      loading: false,
      newFile: null,
      newItem: {
        link: null,
        level: 4,
        name: ''
      },
      titles: [
        { id: 1, name: "Gold" },
        { id: 2, name: "Silver" },
        { id: 3, name: "Bronze" },
        { id: 4, name: "Other" }
      ],
    };
  },
  computed: mapState(["loadingSponsors", "sponsors"]),

  mounted() {
    if (!this.sponsors.length) this.$store.dispatch("cargarSponsors");
  },

  methods: {
    updateItem() {
      this.item = this.sponsors.find(val => val.id === this.id);
    },
    update() {
      this.loading = true;
      if(this.newFile!=null)this.newFileMet();
      if (this.id)
        this.$store
          .dispatch("updateSponsors", this.item)
          .then(() => ((this.loading = false), alert("Updated!")));
    },
    create() {
      this.loading = true;
      if (this.newItem.link != null) {
        let x = this.newItem.link
        this.newItem.link = ''
        let _this=this
        //console.log(x)
        this.$store.dispatch("addSponsors", this.newItem).then(id => {
          uploadPhoto("sponsors", id, x).then(link => {
            //console.log(link)
            _this.newItem.link = link;
            _this.newItem.id = id;
            _this.$store.dispatch("updateSponsors", _this.newItem).then(() => {
              _this.loading = false;
              alert("Content created!");
            });
          });
        });
      } else {
        this.loading = false;
        alert("You need a picture to upload!");
      } 
    },
    delet() {
      this.loading = true;
      if (this.id)
        this.$store
          .dispatch("deleteSponsors", this.item)
          .then(() => (this.loading = false));
      this.item = {};
    },
    newFileMet() {
      uploadPhoto("sponsors", this.item.id, this.newFile).then(link => {
        this.item.link = link;
        this.$store
          .dispatch("updateSponsors", this.item)
          .then(() => alert("Photo updated!"));
      });
    }
  }
};
</script>